var map = {
	"./Autobahn_01.jpg": 5085,
	"./Bahnhof_01.jpg": 9049,
	"./Baustelle_01.jpg": 3824,
	"./Business_01.jpg": 4759,
	"./Dom_01.jpg": 3609,
	"./Einkaufszentrum_01.jpg": 8104,
	"./Energie_01.jpg": 9074,
	"./Fabrik_01.jpg": 3848,
	"./Flughafen_01.jpg": 5063,
	"./Flughafen_02.jpg": 6392,
	"./Forschung_01.jpg": 9028,
	"./Fussball_01.jpg": 803,
	"./Hafen_01.jpg": 5981,
	"./Martha Herford_01.jpg": 1052,
	"./MultiKulti_01.jpg": 1465,
	"./Natur_01.jpg": 33,
	"./Natur_02.jpg": 7894,
	"./StartUp_01.jpg": 5808,
	"./Uni_01.jpg": 3859,
	"./wide/Bahnhof_02.jpg": 3462,
	"./wide/Baustelle_02.jpg": 1143,
	"./wide/Business_02.jpg": 8640,
	"./wide/Dom_02.jpg": 5846,
	"./wide/Einkaufszentrum_02.jpg": 4255,
	"./wide/Energie_02.jpg": 2837,
	"./wide/Fabrik_02.jpg": 2415,
	"./wide/Flughafen_03.jpg": 4669,
	"./wide/Forschung_02.jpg": 2363,
	"./wide/Fussball_02.jpg": 9900,
	"./wide/Hafen_02.jpg": 4474,
	"./wide/Martha Herford_02.jpg": 5667,
	"./wide/MultiKulti_02.jpg": 534,
	"./wide/Natur_03.jpg": 4043,
	"./wide/StartUp_02.jpg": 6503,
	"./wide/Uni_02.jpg": 6988,
	"./wide/Uni_03.jpg": 4777
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6915;